import React, { memo } from 'react';
import QuestionViewer from '../QuestionViewer';
import TextFieldsViewer from './TextQuestionFields/TextFieldsViewer';
import TextFieldsEditor from './TextQuestionFields';
import { ITextQuestionView, QuestionState } from 'store/survey/surveyTypes';
import { appDispatch } from 'store/store';
import { IQuestionViewerProp } from '../GeneralQuestion/GeneralQuestionViewer';

interface IComponentProps extends IQuestionViewerProp {
  question: { data: ITextQuestionView; state: QuestionState };
}

const TextQuestionViewer: React.FC<IComponentProps> = ({
  tags,
  index,
  surveyId,
  question,
  displayDeleted,
  providerSurvey,
  readOnly,
  ...otherProps
}) => {
  const {
    data: { maxLength, inputType },
  } = question;
  return (
    <QuestionViewer
      icon="align-center"
      tags={tags}
      index={index}
      dispatch={appDispatch}
      surveyId={surveyId}
      question={question}
      displayDeleted={displayDeleted}
      providerSurvey={providerSurvey}
      readOnly={readOnly}
      child={(editing: boolean) =>
        !editing ? (
          <TextFieldsViewer maxLength={maxLength} inputType={inputType} />
        ) : (
          <TextFieldsEditor maxLength={maxLength} inputType={inputType} />
        )
      }
      {...otherProps}
    />
  );
};

export default memo(
  TextQuestionViewer,
  (prevProps: IComponentProps, nextProps: IComponentProps) => {
    return (
      prevProps.question === nextProps.question &&
      prevProps.index === nextProps.index &&
      prevProps.questionState === nextProps.questionState
    );
  }
);
